module.exports = __webpack_public_path__ + "img/male7.1ef0d689.jpeg";